import React, { useRef } from "react";
import colors from "../../../utils/colors";
import { useOutsideCloseModal } from "../../../hooks/useOutsideClickModal";

interface IProps {
  openDetailsModal: React.Dispatch<React.SetStateAction<boolean>>;
  openUpdatePatientModal: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
}
const PatientsActionsList = ({
  onClose,
  openDetailsModal,
  openUpdatePatientModal,
}: IProps) => {
  const ref = useRef(null);
  useOutsideCloseModal({ ref, setShowModal: onClose }); //close modal on click outside the modal

  const handleClick = (
    openFn: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    openFn(true);
  };
  const className = `p-2 text-xs cursor-pointer hover:bg-[#D0D0D0] hover:font-bold`;

  return (
    <div
      ref={ref}
      className="absolute bg-[whitesmoke] p-2 w-[150px] right-[-5px] drop-shadow-lg top-[50px] z-50"
    >
      <div className="flex flex-col gap-1" style={{ color: colors.dark }}>
        <div
          className={className}
          onClick={() => handleClick(openDetailsModal)}
        >
          View Details
        </div>
        <div
          className={className}
          onClick={() => handleClick(openUpdatePatientModal)}
        >
          Edit details
        </div>
        <div className={className}>Message</div>
      </div>
    </div>
  );
};

export default PatientsActionsList;
